<header class="mobile-status__header">
  <button
    #navigationButton
    class="mobile-status__navigation-button"
    type="button"
    aria-label="Open navigation"
    aria-controls="layout-sidebar"
    [attr.aria-expanded]="navigationOpen()"
    (click)="commandRequested.emit({ kind: 'open-mobile-navigation' })"
  >
    <i sch-icon="menu"></i>
  </button>
  <span class="mobile-status__workspace">{{ model().workspaceLabel }}</span>
</header>

@if (model().isLoading || model().errorMessage) {
  <div class="mobile-status__alerts" aria-live="polite" aria-atomic="true">
    @if (model().isLoading) {
      <div
        class="mobile-status__alert mobile-status__alert--loading"
        role="status"
      >
        <i
          sch-icon="auto-renew"
          class="mobile-status__alert-icon mobile-status__spin"
        ></i>
        <span>Loading account and workspace context...</span>
      </div>
    }
    @if (model().errorMessage; as errorMessage) {
      <div
        class="mobile-status__alert mobile-status__alert--error"
        role="alert"
        aria-live="assertive"
      >
        <i sch-icon="warning" class="mobile-status__alert-icon"></i>
        <span>{{ errorMessage }}</span>
      </div>
    }
  </div>
}
